exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "workspace-disclaimer-banner {\n  display: block;\n  margin: 0 20px;\n}\nworkspace-disclaimer-banner .has-banner {\n  margin-top: 20px;\n}\n:host {\n  display: block;\n  margin: 0 20px;\n}\n:host .has-banner {\n  margin-top: 20px;\n}\n", ""]);

// exports
